import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export interface EndIFRSExamResponse {
  message: string;
  data?: any;
}

type EndIFRSExamAPIResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: EndIFRSExamResponse;
};

export const EndIFRSExam = async (
  ifrsStudentExamId: string
): Promise<EndIFRSExamAPIResponse> => {
  try {
    const response = await axios.post(
      `/student/ifrs/${ifrsStudentExamId}/submit-exam`
    );
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};

